import ClusterGraphResponseTransformed from "../../../domains/ClusteringGraph/ClusterGraphResponseTransformed";

import * as types from "./types";

export function generateClusterGraph() {
  return {
    type: types.GENERATE_CLUSTER_GRAPH,
    payload: {
      isDataLoading: true,
    },
  };
}

export function generateClusterGraphSuccess(
  clusterGraphData: ClusterGraphResponseTransformed,
) {
  return {
    type: types.GENERATE_CLUSTER_SUCCESS,
    payload: {
      clusterGraphData,
      isDataLoading: false
    },
  };
}

export function generateClusterGraphError() {
  return {
    type: types.GENERATE_CLUSTER_ERROR,
    payload: {
      isDataLoading: false,
      hasErrorLoadingData: true,
    },
  };
}

export function openGraphModal() {
  return {
    type: types.OPEN_GRAPH_MODAL,
    payload: {
      isGraphModalOpen: true,
    },
  };
}

export function closeGraphModal() {
  return {
    type: types.OPEN_GRAPH_MODAL,
    payload: {
      isGraphModalOpen: false
    }
  };
}
